"use client";

import React, { useRef } from "react";
import type { Product } from "@/types";
import ProductCard from "@/components/ProductCard";

interface Props {
  products: Product[];
  title?: string;
}

// Horizontaal scrollende "uitgelicht"-balk op categoriepagina's — de eigenaar
// kiest de producten en de volgorde zelf in de admin (categorieën > Uitgelicht).
// Geen sleep/autoplay, gewoon scrollbaar met muis/touch + optionele pijltjes.
export default function FeaturedProductsSlider({ products, title = "UITGELICHT" }: Props) {
  const trackRef = useRef<HTMLDivElement>(null);

  if (!products || products.length === 0) return null;

  function scrollByPage(dir: 1 | -1) {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * el.clientWidth * 0.8, behavior: "smooth" });
  }

  return (
    <div className="featured-slider">
      <div className="featured-slider-header">
        <h2 className="featured-slider-title">{title}</h2>
        <div className="featured-slider-arrows">
          <button type="button" className="featured-slider-arrow" onClick={() => scrollByPage(-1)} aria-label="Vorige producten">‹</button>
          <button type="button" className="featured-slider-arrow" onClick={() => scrollByPage(1)} aria-label="Volgende producten">›</button>
        </div>
      </div>
      <div className="featured-slider-track" ref={trackRef}>
        {products.map((p) => (
          <div className="featured-slider-item" key={p.id}>
            <ProductCard product={p} />
          </div>
        ))}
      </div>
    </div>
  );
}
